//for products
export const ADMIN_GET_DATA_REQUEST = "admin/getDataRequest";

export const ADMIN_GET_DATA_SUCCESS = "admin/getDataSuccess";

export const ADMIN_GET_DATA_ERROR = "admin/getDataError";



export const ADMIN_POST_DATA_REQUEST = "admin/postDataRequest";

export const ADMIN_POST_DATA_SUCCESS = "admin/postDataSuccess";

export const ADMIN_POST_DATA_ERROR = "admin/postDataError";



export const ADMIN_EDIT_DATA_REQUEST = "admin/editDataRequest";

export const ADMIN_EDIT_DATA_SUCCESS = "admin/editDataSuccess";

export const ADMIN_EDIT_DATA_ERROR = "admin/editDataError";



export const ADMIN_DELETE_DATA_REQUEST = "admin/deleteDataRequest";

export const ADMIN_DELETE_DATA_SUCCESS = "admin/deleteDataSuccess";

export const ADMIN_DELETE_DATA_ERROR = "admin/deleteDataError";


//for users

export const ADMIN_USERS_DATA_REQUEST = "admin/usersDataRequest";

export const ADMIN_USERS_DATA_SUCCESS = "admin/usersDataSuccess";

export const ADMIN_USERS_DATA_ERROR = "admin/usersDataError";


export const ADMIN_REQUEST = "admin/Request";

export const ADMIN_DELETE_USERS_DATA_SUCCESS = "admin/usersDatadeleteSuccess";

export const ADMIN_ERROR = "admin/Error";


export const ADMIN_USERS_ORDER_DATA_SUCCESS = "admin/usersOrderSuccess";


